'use client'

import dynamic from 'next/dynamic'

import LazyMount from '@/components/LazyMount'

const StoryChapters = dynamic(() => import('@/components/StoryChapters'), {
  ssr: false,
  loading: () => <div className="min-h-screen bg-[#060606]" />,
})

// The reel is heavy (video + animation libs) and sits below the fold — its
// chunk downloads when the visitor approaches, not during first-load
// hydration.
export default function StoryChaptersLoader() {
  return (
    <LazyMount minHeight="100vh">
      <StoryChapters />
    </LazyMount>
  )
}
